/** Eén bron voor cookievoorkeuren: gebruikt door de banner en de instellingenpagina. */
export const COOKIE_CONSENT_KEY = "taxiritje-cookie-consent";

export type CookiePrefs = { functional: boolean; analytics: boolean };

/**
 * Uitgangspunt zonder geldige toestemming: niet-noodzakelijke cookies staan
 * uit. Dit wordt ook gebruikt als beginstand van de instellingenpagina, zodat
 * er nooit een trackingcategorie vooraf aangevinkt staat.
 */
export const COOKIE_DEFAULTS: CookiePrefs = { functional: false, analytics: false };

/** Leest de opgeslagen voorkeuren; `null` betekent: nog geen keuze gemaakt. */
export function readCookiePrefs(): CookiePrefs | null {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    return { ...COOKIE_DEFAULTS, ...(JSON.parse(raw) as Partial<CookiePrefs>) };
  } catch {
    return null;
  }
}

export function writeCookiePrefs(prefs: CookiePrefs) {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(prefs));
    return true;
  } catch {
    return false;
  }
}
